import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { IconButton, InputAdornment } from '@mui/material';
import Grid from '../../component/form/Grid';
import TextField from '../../component/form/TextField';
import Checkbox from '../../component/form/Checkbox';
import Select from '../../component/form/Select';
import { getSiteConfig } from '../../environment';
import { isNullOrUndefined } from '../../util/objects';
import Label from '../../component/form/Label';
import SelectOffice from '../../component/form/SelectOffice';
import { AltButton } from '../../component/form/PrimaryButton';
import { GST } from '../../util/products';
import { DeleteIcon } from '../../component/IconIndex';
import ColumnLayout from '../../component/ColumnLayout';
import BiggerMessageBar from '../../component/BiggerMessageBar';

class StockItemPricing extends Component {
    render() {
        const { form } = this.props;
        const variations = form.getField('Variations');
        const { XeroAccountsFM } = getSiteConfig();
        let allAccounts = { costs: [], sales: [] };
        try {
            allAccounts = JSON.parse(XeroAccountsFM) || {};
        } catch (e) {
            // dude, where's my accounts?
        }
        const sales = Object.keys(allAccounts.sales).map(key => ({ label: allAccounts.sales[key], value: key }));
        const costs = Object.keys(allAccounts.costs).map(key => ({ label: allAccounts.costs[key], value: key }));
        return (
            <Grid container spacing={3}>
                {!!variations && !!variations.length && (
                    <Grid item xs={12}>
                        <BiggerMessageBar messageType="warning">
                            This product has variations, so the prices listed here are only used for quotes. Please set
                            actual pricing on each variation - to be applied for bookings, invoices & bills.
                        </BiggerMessageBar>
                    </Grid>
                )}
                <div style={{ padding: 9 }} />
                <ColumnLayout>
                    <Grid container>{this.renderCosts(costs)}</Grid>
                    <Grid container>
                        {this.renderSales(sales)}
                        {this.renderOverrides()}
                    </Grid>
                </ColumnLayout>
                <div style={{ padding: 9 }} />
            </Grid>
        );
    }

    renderCosts(costs) {
        const { form } = this.props;
        const costsCode = form.getField('XeroCostsCode');
        if (costs.length && !isNullOrUndefined(costsCode)) {
            if (!costs.find(obj => costsCode === obj.value)) {
                costs.unshift({ label: `[${costsCode}] UNKNOWN`, value: costsCode });
            }
        }
        const setBaseWorth = (evt, val) => {
            const applyGST = !!form.getField('ITC');
            form.setField({ BaseWorth: applyGST ? val / (GST + 1) : val });
        };
        const applyITC = form.getField('ITC');
        return (
            <Grid bucket>
                <Grid item xs={12}>
                    <Label>Purchase (Bills)</Label>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        form={form}
                        name="PurchasePrice"
                        type="number"
                        label={'Purchase Cost' + (applyITC ? ' (inc.GST)' : ' (GST-Free)')}
                        InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                        onChange={setBaseWorth}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    {costs && costs.length ? (
                        <Select form={form} name="XeroCostsCode" label="Purchases Account" options={costs} />
                    ) : (
                        <TextField form={form} name="XeroCostsCode" label="Purchases Account" />
                    )}
                </Grid>
                <Grid item xs={12}>
                    <Checkbox form={form} name="ITC" label="Item purchase is subject to GST" />
                </Grid>
            </Grid>
        );
    }

    renderSales(sales) {
        const { form } = this.props;
        const salesCode = form.getField('XeroSalesCode');
        if (sales.length && !isNullOrUndefined(salesCode)) {
            if (!sales.find(obj => salesCode === obj.value)) {
                sales.unshift({ label: `[${salesCode}] UNKNOWN`, value: salesCode });
            }
        }
        const setBasePrice = (evt, val) => {
            const applyGST = !!form.getField('GST');
            form.setField({ BasePrice: applyGST ? val / (GST + 1) : val });
        };
        const applyGST = form.getField('GST');
        return (
            <Grid container>
                <Grid item xs={12}>
                    <Grid bucket>
                        <Grid item xs={12}>
                            <Label>Sales (Invoices & Quotes)</Label>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                form={form}
                                name="SellingPrice"
                                type="number"
                                label={'Retail Price' + (applyGST ? ' (inc.GST)' : ' (GST-Free)')}
                                InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                                onChange={setBasePrice}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            {sales && sales.length ? (
                                <Select form={form} name="XeroSalesCode" label="Sales Account" options={sales} />
                            ) : (
                                <TextField form={form} name="XeroSalesCode" label="Sales Account" />
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            <Checkbox form={form} name="GST" label="Item sale is subject to GST" />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    renderOverrides() {
        const { form, classes } = this.props;
        const applyGST = !!form.getField('GST');
        const overrides = form.getField('PriceOverrides') || [];
        const disabledOfficeIDs = overrides.map(obj => obj.ID);

        const setBasePrice = (val, idx) => {
            const override = overrides[idx];
            if (applyGST) {
                override.BasePrice = val / (GST + 1);
            } else {
                override.BasePrice = val;
            }
            form.setField({ PriceOverrides: overrides });
        };

        const handleAddPrice = () => {
            overrides.push({});
            form.setField({ PriceOverrides: overrides });
        };

        const handleDelPrice = idx => {
            overrides.splice(idx, 1);
            form.setField({ PriceOverrides: overrides });
        };

        return (
            <Grid container>
                <Grid item xs={12}>
                    <Grid bucket>
                        <Grid item xs={12}>
                            <Label>Price Overrides</Label>
                            {!overrides.length && <p>There are currently no price overrides.</p>}
                        </Grid>
                        <Grid item xs={12}>
                            {overrides.map((node, idx) => {
                                const nameField = `PriceOverrides[${idx}]`;
                                return (
                                    <Grid container className={classes.listItem} key={node.ID || 'k' + idx}>
                                        <Grid item xs={12} sm={7}>
                                            <SelectOffice
                                                fullWidth
                                                allowNone={false}
                                                form={form}
                                                name={`${nameField}.ID`}
                                                label={'Brand/Branch'}
                                                disabledOfficeIDs={disabledOfficeIDs}
                                                allowParent
                                            />
                                        </Grid>
                                        <Grid item xs={10} sm={4}>
                                            <TextField
                                                form={form}
                                                name={`${nameField}.SellingPrice`}
                                                type="number"
                                                label={'Retail Price' + (applyGST ? ' (inc.GST)' : ' (GST-Free)')}
                                                InputProps={{
                                                    startAdornment: <InputAdornment position="start">$</InputAdornment>
                                                }}
                                                onChange={(evt, val) => setBasePrice(val, idx)}
                                            />
                                        </Grid>
                                        <Grid item xs={2} sm={1}>
                                            <IconButton
                                                className={classes.iconButton}
                                                onClick={() => handleDelPrice(idx)}
                                            >
                                                <DeleteIcon className={classes.deleteIcon} />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                );
                            })}
                        </Grid>
                        <Grid item xs={12}>
                            <AltButton onClick={handleAddPrice}>+ Add Brand Price</AltButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

const styles = ({ palette }) => ({
    listItem: {
        width: '100%',
        padding: '0 0 8px 0',
        margin: '6px 0 0 !important',
        borderRadius: 5,
        position: 'relative',
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.05)'
        },
        '& > div': {
            padding: 8
        }
    },
    iconButton: {
        marginLeft: -10,
        marginTop: 16,
        width: 32,
        height: 32,
        '& svg': { width: 18, height: 18 }
    },
    deleteIcon: {
        color: palette.button.destroy
    }
});

export default withStyles(styles)(StockItemPricing);
